import { httpGet, httpPost } from "../Web"
import { ApiResponse } from "./ApiResponse";

export interface WorkshopProductInterface {
    id?: number,
    guid?: string,
    serverEndpoint?: string,
    supportedByProduct: boolean,
    interfaceId: number,
    workshopProductId: number
}

export const getWorkshopProductInterfaces = async (wpId: number, abortController: AbortController) =>
    httpGet(`/api/workshopproduct/interface/${wpId}`, abortController);

export const updateWsProdIface = (wspiface: WorkshopProductInterface, abortController: AbortController): Promise<ApiResponse<WorkshopProductInterface>> =>
    httpPost(`/api/workshopproduct/interface/update/`, wspiface, abortController);
